import OptionItem from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem'
import QuantityAdjuster from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem/Multi/parts/QuantityAdjuster'
import { FC, memo } from 'react'

interface MultiOptionItemProps {
    id: string
    disabled?: boolean
    name: string
    price: string
    quantity: number
    onQuantityChange: (id: string, quantity: number) => void
}

const MultiOptionItem: FC<MultiOptionItemProps> = ({
    id,
    disabled,
    quantity,
    onQuantityChange,
    ...props
}) => {
    const selected = quantity > 0

    const handleQuantityChange = (quantity: number) => onQuantityChange(id, quantity)

    return (
        <OptionItem
            {...props}
            id={id}
            selected={selected}
            disabled={disabled}
            onPress={() => handleQuantityChange(quantity + 1)}
            TailComponent={
                !disabled && (
                    <QuantityAdjuster quantity={quantity} onQuantityChange={handleQuantityChange} />
                )
            }
        />
    )
}

export default memo(MultiOptionItem)
